import {ReactNode} from "react";
import { MemberDataDto } from "./MemberDataDto";

export default interface ZooPassLocalStateData
{
    step: number;
    previousStep: number;
    /**
     * Who is this pass for?
     */
    step1Value: null | 0 | 1;
    /**
     * New or renewal?
     */
    step2Value: null | 0 | 1;
    /**
     * If it's a renewal, what is the id
     */
    step2RenewalPassId: null | number;
    /**
     * Number of adults
     */
    step3Value: null | 1 | 2;
    /**
     * Holds form data such as name, address, email, phone, etc.
     */
    formData: MemberDataDto;
    /**
     * Number of minors / radio selected
     */
    step4Value: null | 0 | 1 | 2 | 3 | 4;
    /**
     * If 4 selected, select number of 4 or above
     */
    step4DropdownValue: null | 4 | 5 | 6 | 7 | 8 | 9;
    /**
     * The combined value of step4Value and step4DropdownValue
     */
    step4FinalValue: null | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
    /**
     * Include guests
     */
    step5Value: null | 0 | 1 | 2 | 3 | 4;
    /**
     * Include parking?
     */
    step6Value: null | 0 | 1;
    /**
     * The pass selected (ID)
     */
    step7Value: null | string;
    /**
     * Pass timeframe (in years)
     */
    step8Value: null | 1 | 2 | 3;
    /**
     * The final id being selected which represents a potential upgraded timespan - this will be ultimately passed
     */
    step8IdValue: null | string;
    /**
     * Controls the contents of the step 9 panel
     */
    finalizing: ZooPassLocalStateDataFinalizeState | null;
}

export interface ZooPassLocalStateDataFinalizeState {
    initializing: ZooPassLocalStateDataFinalizeItemState | null;
    getChildrenSelection: ZooPassLocalStateDataFinalizeItemState | null; 
    login: ZooPassLocalStateDataFinalizeItemState | null;
    setChildren: ZooPassLocalStateDataFinalizeItemState | null;
    redirecting: ZooPassLocalStateDataFinalizeItemState | null;
    memberLevelNo?: number | null;
}

export interface ZooPassLocalStateDataFinalizeItemState {
    label?: string | null | undefined;
    description?: string | null | undefined;
    status : ZooPassLocalStateDataFinalizeItemStateStatus;
}

export enum ZooPassLocalStateDataFinalizeItemStateStatus {
    Disabled = 0,   //ban-fill
    Ready = 1,      //square
    Current = 2,    //hourglass-split
    Failed = 3,     //exclamation-square-fill
    Success = 4,    //check-square-fill
    Unknown = 5,    //question-square
}